import type { AalExportPayload, AalView } from "../aalV2";
import { useAalExport } from "../aalV2";

export type DownloadAALSuspensionsPayload = AalExportPayload & {
  action_type?: string;
  agent_id?: string;
  agent_role_id?: string;
  target_user_id?: string;
  username?: string;
};

export const useDownloadAALSuspensionsTable = (view: AalView) =>
  useAalExport("suspensions", view);
